import cn from 'classnames'
import React from 'react'
import Icon from '../tntd-icon'
import Box from './Box'
import { addUnitForValue, computeWidth } from './utils'

import './index.less'

const clsPrefix = 'tntd-page'

const isPageBox = (child) => child?.type === Box || child?.props?.pageBox

const PageLayout = ({
  height = '100vh',
  headerHeight = 50,
  children,
  title,
  goBack,
  goBackText,
  center,
  extra,
  size = 'small',
  inLayout = false,
  className,
  ...restProps
}) => {
  // 如果传入只有数字，需要默认加px
  let computedHeaderHeight = addUnitForValue(headerHeight)
  let computedHeight = addUnitForValue(height)

  // 判断是否有标题栏
  if (!(title || extra || center)) {
    computedHeaderHeight = '0px'
  }

  if (inLayout) {
    computedHeaderHeight = '40px'
  }

  // 计算中间的zIndex，灰色递减，白色递增
  let whiteCols = 0
  let childrenToArray = []

  // 计算children type是box的数量
  let boxCount = 0

  // 如果children是单个节点，统一转为数组处理计算层级

  if (typeof children === 'object') {
    childrenToArray = [children]
  } else if (Array.isArray(children)) {
    childrenToArray = [...children]
  }

  React.Children.map(children, (child) => {
    if (isPageBox(child)) {
      boxCount += 1
    }
  })

  whiteCols = childrenToArray?.filter(({ props }) => props?.mode === 'white')?.length
  const total = childrenToArray?.length + 5
  let startIndex = total - whiteCols - 1
  let endIndex = total - 2
  const headerStyle = {
    height: computedHeaderHeight,
    padding: `${size === 'small' ? 20 : 24}px`,
    zIndex: inLayout ? 1 : total || 1,
  }
  const contentStyle = {
    display: boxCount > 0 ? 'flex' : 'block',
    marginTop: computedHeaderHeight,
    padding: inLayout ? '16px 20px' : '0px',
  }

  return (
    <section
      className={cn(clsPrefix, {
        [className]: className,
        'in-layout': inLayout,
        'not-in-layout': !inLayout,
      })}
      {...restProps}
    >
      {(title || goBack || center || extra) && (
        <div className={`${clsPrefix}-header`} style={headerStyle}>
          <div className={`${clsPrefix}-header-section`}>
            {goBack && (
              <div
                className="page-header-section-back"
                onClick={() => {
                  goBack()
                }}
              >
                <Icon type="left" />
                <span>{goBackText ? goBackText : '返回'}</span>
              </div>
            )}
            {title}
          </div>
          {[center, extra].map((item, i) => (
            <div className={`${clsPrefix}-header-section`} key={i}>
              {item}
            </div>
          ))}
        </div>
      )}
      <div className={`${clsPrefix}-content`} style={contentStyle}>
        {React.Children.map(children, (child) => {
          // 如果children不是Box,就不需要多列布局
          if (!child.type) {
            return React.cloneElement(<div>{child}</div>)
          }

          const extraProps = {
            headerHeight: computedHeaderHeight,
            size,
            height: computedHeight,
            contentTotalMargin: inLayout ? '32px' : '0px',
            inLayout,
            ...child.props,
          }

          if (!isPageBox(child)) {
            return React.cloneElement(child, extraProps)
          }

          const { mode = 'gray', width } = child.props

          const style = {
            flex: computeWidth(width),
            // 设置cols层级关系
            zIndex: mode === 'gray' ? endIndex-- : startIndex++,
          }

          const className = cn(`${clsPrefix}-box ${clsPrefix}-box-${mode}`)

          return React.createElement(
            'div',
            { className, style },
            React.cloneElement(child, extraProps)
          )
        })}
      </div>
    </section>
  )
}

PageLayout.Box = Box

export default PageLayout
